const cards = [
  {
    title: '神马影视',
    tag: '热门资源',
    desc: '热播资源丰富，更新速度快，院线大片与热播剧集同步上线，高清画质畅快观影。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20with%20popular%20movie%20posters%20grid%20display%2C%20clean%20UI%20design%2C%20warm%20ambient%20lighting%2C%20tech%20lifestyle%20photography%2C%20professional%20composition%20with%20cinematic%20mood&width=800&height=500&seq=card-sm-1&orientation=landscape',
    alt: '神马影视 - 热门影视资源',
  },
  {
    title: '樱花影视',
    tag: '日韩专区',
    desc: '日韩资源齐全，画质清晰流畅，日剧韩剧动漫全品类覆盖，中文字幕同步更新。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20and%20Korean%20drama%20collection%20aesthetic%20display%2C%20warm%20cherry%20blossom%20and%20soft%20cinematic%20lighting%2C%20elegant%20film%20curation%20atmosphere%2C%20artistic%20professional%20photography%20with%20gentle%20tones&width=800&height=500&seq=card-yh-2&orientation=landscape',
    alt: '樱花影视 - 日韩影视资源',
  },
  {
    title: '小小影视',
    tag: '经典老片',
    desc: '老片资源丰富，经典影视作品一应俱全，怀旧专区带你重温那些年追过的剧。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20vintage%20film%20collection%20display%20with%20old%20movie%20posters%20aesthetic%2C%20warm%20nostalgic%20golden%20atmosphere%2C%20retro%20cinema%20vibe%2C%20artistic%20composition%20with%20film%20memorabilia%2C%20soft%20lighting%20photography&width=800&height=500&seq=card-xx-3&orientation=landscape',
    alt: '小小影视 - 经典影视资源',
  },
  {
    title: '久久影视',
    tag: '高清稳定',
    desc: '高清片源稳定流畅，智能选源技术保障观影体验，告别卡顿尽情享受大片。',
    img: 'https://readdy.ai/api/search-image?query=High%20definition%20streaming%20quality%20concept%2C%20crystal%20clear%20display%20showing%20movie%20scene%2C%20modern%20technology%20aesthetic%2C%20professional%20photography%2C%20clean%20composition%20with%20cinematic%20lighting&width=800&height=500&seq=card-jj-4&orientation=landscape',
    alt: '久久影视 - 高清影视资源',
  },
  {
    title: '飘花影视',
    tag: '最新院线',
    desc: '最新院线大片同步更新，第一时间呈现热门电影，让你足不出户看遍新片。',
    img: 'https://readdy.ai/api/search-image?query=Latest%20cinema%20blockbuster%20movie%20collection%20display%2C%20movie%20premiere%20atmosphere%20with%20warm%20dramatic%20lighting%2C%20professional%20entertainment%20photography%2C%20cinematic%20composition%20with%20excitement%20mood&width=800&height=500&seq=card-ph-5&orientation=landscape',
    alt: '飘花影视 - 最新院线资源',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            聚合八大主流平台优质资源，为你精选最值得看的内容
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 5).map((card, i) => (
            <article
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500 text-white whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}